export const EMAILS_TYPE = "emails";
export const MEMBERS_TYPE = "members";
export const CONTACT_GROUPS_TYPE = "contactGroups";
export const CONTACTS_TYPE = "contacts";
export const SPONSORS_TYPE = "sponsors";
export const EVENTS_TYPE = "events";
export const ASSETS_TYPE = "assets";

export type EntityType = typeof EMAILS_TYPE | typeof MEMBERS_TYPE | typeof CONTACT_GROUPS_TYPE | typeof CONTACTS_TYPE | typeof SPONSORS_TYPE | typeof EVENTS_TYPE | typeof ASSETS_TYPE;
